import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const assetRegisterNames = api(async function assetRegisterNames() {
    return query(
        gql`
            query GetAssetRegisterNames {
                assetRegisterNames {
                    id
                    name
                }
            }
        `,
        {},
        { returns: "assetRegisterNames" }
    )
})
